<template>
    <div>
        <button @click="saveResults" class="save-btn">{{ saved ? 'SAVED' : text }}</button>

        <transition name="fade" mode="out-in">
            <light-box v-show="show_lightbox" @close="close_lightbox" text="Your regimen has been successfully saved and will be displayed when you return to the Skincare Consultation" />
        </transition>
    </div>
</template>

<script>
import { cookie_key } from '../utilities'
import LightBox from './lightbox.vue'

export default {
    name: 'ButtonToSaveResults',
    components: {
        LightBox,
    },
    props: {
        text: {
            type: String,
            default: () => 'SAVE MY RESULTS',
        },
    },
    data() {
        return {
            saved: false,
            show_lightbox: false,
        }
    },
    methods: {
        saveResults() {
            if (!this.saved) {
                this.saved = true
                this.$cookie.set(cookie_key, this.$route.path, 365)
                this.show_lightbox = true

                setTimeout(() => {
                    this.show_lightbox = false
                }, 3000)
            }
        },
        close_lightbox() {
            this.show_lightbox = false
        },
    },
}
</script>


// WEBPACK FOOTER //
// source/app/js/components/btn_save-results.vue